import {Component, Input, NgModule} from '@angular/core';

@Component({
  selector: 'sd-progress-bar',
  standalone: true,
  template: `
    <div class="h-1 w-full overflow-hidden rounded-full bg-neutral-200">
      <div
        class="h-full bg-[var(--m365-accent,#111)]"
        [class.animate-pulse]="mode !== 'determinate'"
        [style.width.%]="mode === 'determinate' ? value : 60"
      ></div>
    </div>
  `,
  host: {class: 'sd-progress-bar sd-progress-bar block w-full'},
})
export class SdProgressBar {
  @Input() mode: 'determinate' | 'indeterminate' | 'buffer' | 'query' = 'indeterminate';
  @Input() value = 0;
  @Input() color: string | undefined;
}

@NgModule({
  imports: [SdProgressBar],
  exports: [SdProgressBar],
})
export class SdProgressBarModule {}
